// src/pages/HomePage.js
import React from 'react';
import { Typography, Button, Paper, Box, Container, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import BarChartIcon from '@mui/icons-material/BarChart';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import BusinessIcon from '@mui/icons-material/Business';
import GroupIcon from '@mui/icons-material/Group';
import DescriptionIcon from '@mui/icons-material/Description';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            mb: 6,
          }}
        >
          <Typography variant="h2" component="h1" gutterBottom>
            Pitch Deck Analyzer
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            Analyze any pitch deck with AI-powered technology
          </Typography>
          <Button
            variant="contained"
            size="large"
            startIcon={<UploadFileIcon />}
            onClick={() => navigate('/upload')}
            sx={{ mt: 3 }}
          >
            Upload Pitch Deck
          </Button>
        </Box>



        <Box sx={{ mt: 8, mb: 4 }}>
  
          <Typography variant="body1" paragraph align="center" sx={{ mb: 4 }}>
            Our technology analyzes all important aspects of any pitch deck:
          </Typography>
          
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* First row with 3 connected items */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Paper elevation={2} sx={{ p: 2, textAlign: 'center', flex: 1 }}>
                <LightbulbIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Elevator Pitch</Typography>
                <Typography variant="body2" color="text.secondary">
                  Precise and convincing
                </Typography>
              </Paper>
              <ArrowRightAltIcon sx={{ color: 'primary.main', fontSize: 30 }} />
              <Paper elevation={2} sx={{ p: 2, textAlign: 'center', flex: 1 }}>
                <GroupIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Team Analysis</Typography>
                <Typography variant="body2" color="text.secondary">
                  Skills and experience
                </Typography>
              </Paper>
              <ArrowRightAltIcon sx={{ color: 'primary.main', fontSize: 30 }} />
              <Paper elevation={2} sx={{ p: 2, textAlign: 'center', flex: 1 }}>
                <DescriptionIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Product Analysis</Typography>
                <Typography variant="body2" color="text.secondary">
                  Features and benefits
                </Typography>
              </Paper>
            </Box>

            {/* Second row with 3 connected items */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Paper elevation={2} sx={{ p: 2, textAlign: 'center', flex: 1 }}>
                <BusinessIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Market Analysis</Typography>
                <Typography variant="body2" color="text.secondary">
                  Competition and positioning
                </Typography>
              </Paper>
              <ArrowRightAltIcon sx={{ color: 'primary.main', fontSize: 30 }} />
              <Paper elevation={2} sx={{ p: 2, textAlign: 'center', flex: 1 }}>
                <MonetizationOnIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Finance</Typography>
                <Typography variant="body2" color="text.secondary">
                  Business model and KPIs
                </Typography>
              </Paper>
              <ArrowRightAltIcon sx={{ color: 'primary.main', fontSize: 30 }} />
              <Paper elevation={2} sx={{ p: 2, textAlign: 'center', flex: 1 }}>
                <StackedBarChartIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                <Typography variant="h6">Finance Planning</Typography>
                <Typography variant="body2" color="text.secondary">
                  Long-term financial strategy
                </Typography>
              </Paper>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default HomePage;
